import axios from "axios";
import { ActionTypes } from "../types";

export const submitSquadSelection = () => async (dispatch, getState) => {
  const { user, selectedCharacters, theater } = getState();
  dispatch({
    type: ActionTypes.CLOSE_MODAL,
    payload: true,
  });
  dispatch({
    type: ActionTypes.SET_LOADING,
    payload: true,
  });

  await axios
    .put(`/put_entry`, { ...user, squad: selectedCharacters, ...theater })
    .then(({ data }) => {
      const {
        entryId,
        email,
        name,
        squad,
        theater_name,
        created_at,
        scoreDetails,
      } = data;
      const squadSubmission = {
        entryId,
        email,
        name,
        squad,
        theater_name,
        created_at,
      };

      if (data.errorMessage) {
        dispatch({
          type: ActionTypes.SET_MODAL,
          payload: {
            open: true,
            message: data.errorMessage,
          },
        });
      } else {
        dispatch({
          type: ActionTypes.SET_LOADING,
          payload: false,
        });
        dispatch({
          type: ActionTypes.SET_SQUAD_SUBMISSION,
          payload: { squadSubmission },
        });
        dispatch({
          type: ActionTypes.SET_SCORE,
          payload: scoreDetails,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch({
        type: ActionTypes.SET_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.SET_MODAL,
        payload: {
          open: true,
          message: err.response?.data?.errorMessage,
        },
      });
    });
};
